import { createI18n } from 'vue-i18n';

export default createI18n({
    locale: localStorage.getItem('lang'),
    fallbackLocale: 'en',
    legacy: true,
    messages: {},
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    globalInjection: true,
});
